var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('HeadMetadata',{attrs:{"title":_vm.pageTitle}}),_vm._v(" Please wait while Vignette is loading... ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }